if($('.type-category').length){
    if($('.category-top img[alt*="podkladovy obrazek"]').length){
        $('.category-top').addClass('top-image').attr('style', 'background-image:url("'+$('.category-top img[alt*="podkladovy obrazek"]').attr('src')+'")')
        $('.category-top img[alt*="podkladovy obrazek"]').closest('p').remove()
        $('.breadcrumbs').addClass('top-bread').wrap('<div class="container"></div>')
    }
    $('.category-top').wrapInner('<div class="container"></div>')
    $('.category-content-wrapper').prepend($('#productsTop'))

    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        if($('.category-top img[alt*="podkladovy obrazek"]').length){
            $('.category-top').addClass('top-image').attr('style', 'background-image:url("'+$('.category-top img[alt*="podkladovy obrazek"]').attr('src')+'")')
            $('.category-top img[alt*="podkladovy obrazek"]').closest('p').remove()
           
        }
        $('.category-top').wrapInner('<div class="container"></div>')
        $('.category-content-wrapper').prepend($('#productsTop'))
    })
    
}